var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextparetoLayoutScheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 122,
    viewBox: "0 0 176 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 71,
    width: 32,
    height: 8,
    rx: 2,
    fill: "#0A71CE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 81,
    width: 24,
    height: 8,
    rx: 2,
    fill: "#0A71CE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 91,
    width: 16,
    height: 8,
    rx: 2,
    fill: "#0A71CE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 101,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#0A71CE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 172,
    height: 118,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 76,
    width: 8,
    height: 32,
    rx: 2,
    fill: "#0A71CE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 84,
    width: 8,
    height: 24,
    rx: 2,
    fill: "#0A71CE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 92,
    width: 8,
    height: 16,
    rx: 2,
    fill: "#0A71CE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 84,
    width: 8,
    height: 24,
    rx: 2,
    fill: "#0A71CE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 76,
    width: 8,
    height: 32,
    rx: 2,
    fill: "#0A71CE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 92,
    width: 8,
    height: 16,
    rx: 2,
    fill: "#0A71CE"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 100,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#0A71CE"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 84,
    width: 8,
    height: 24,
    rx: 2,
    fill: "#0A71CE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 30,
    width: 68,
    height: 28,
    rx: 2,
    fill: "#0A71CE",
    fillOpacity: 0.5,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 30,
    width: 68,
    height: 28,
    rx: 2,
    fill: "#0A71CE",
    fillOpacity: 0.5,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 68,
    height: 12,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 10,
    width: 68,
    height: 12,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextparetoLayoutScheme);
export default __webpack_public_path__ + "static/media/textparetoLayoutScheme.2979dcb80b30fd67de119ba626367243.svg";
export { ForwardRef as ReactComponent };